<template>
  <div style="margin-top: 70px">
    <v-container class="mt-5">
      <!-- <div class="ma-auto" v-if="error">
        <v-layout text-center wrap>
          <app-alert @dismissed="onDismissed" :message="error.message"></app-alert>
        </v-layout>
      </div>-->
      <v-layout text-center wrap>
        <v-flex xs12>
          <v-card
            class="ma-auto pa-2"
            text
            filled
            style="
                  border-radius: 26px;
                  border: 1px solid #18CAE6;
                  max-width: 600px;
                  
                "
          >
            <v-card-title>
              SIGN
              <span class="red--text">UP</span>
            </v-card-title>

            <v-form class="ma-2 pa-2" @submit.prevent="onSignUp">
              <v-expand-transition>
                <div>
                  <!-- <v-card
                    style="background-color: black; border-radius: 26px; max-width: 500px"
                    outlined
                    tile
                    rounded
                    class="ma-auto"
                  > -->
                  <!-- <v-card-title class="font-weight-light">YOU</v-card-title> -->
                  <!-- FULL NAME  -->
                  <v-text-field
                    label="FULL NAME"
                    name="fullName"
                    validate-on-blur
                    required
                    id="fullName"
                    class="ma-2"
                    outlined
                    v-model="fullName"
                    autofocus
                    clearable
                    dense
                  ></v-text-field>
                  <!-- EMAIL  -->
                  <v-text-field
                    label="EMAIL"
                    name="email"
                    validate-on-blur
                    required
                    id="email"
                    class="ma-2"
                    outlined
                    v-model="email"
                    clearable
                    :rules="[rules.email]"
                    type="email"
                    dense
                  ></v-text-field>
                  <!-- PASSWORD  -->
                  <v-text-field
                    label="PASSWORD"
                    name="password"
                    validate-on-blur
                    required
                    id="password"
                    class="ma-2"
                    outlined
                    v-model="password"
                    clearable
                    type="password"
                    :rules="[rules.length(6)]"
                    counter="6"
                    dense
                  ></v-text-field>
                  <!-- CONFIRM PASSWORD  -->
                  <v-text-field
                    label="CONFIRM PASSWORD"
                    name="confirmPassword"
                    validate-on-blur
                    required
                    id="confirmPassWord"
                    class="ma-2"
                    outlined
                    v-model="confirmPassword"
                    clearable
                    type="password"
                    :rules="[rules.length(6)]"
                    counter="6"
                    dense
                  ></v-text-field>

                  <!-- PHONE  -->
                  <v-text-field
                    label="PHONE"
                    name="phonE"
                    validate-on-blur
                    required
                    id="phone"
                    class="ma-2"
                    outlined
                    v-model="phone"
                    v-mask="mask"
                    clearable
                    type="tel"
                    dense
                  ></v-text-field>
                  <v-text-field
                    label="FAX"
                    name="fax"
                    validate-on-blur
                    required
                    id="fax"
                    class="ma-2"
                    outlined
                    v-model="fax"
                    v-mask="mask"
                    clearable
                    type="tel"
                    dense
                  ></v-text-field>
                  <!-- <v-card-title class="font-weight-light">
                          YOUR
                          <span class="red--text">.</span>FIRM
                        </v-card-title>-->
                  <!-- FIRM NAME -->
                  <v-text-field
                    label="FIRM NAME"
                    name="fullName"
                    validate-on-blur
                    required
                    id="firmName"
                    class="ma-2"
                    outlined
                    v-model="firmName"
                    clearable
                    dense
                  ></v-text-field>

                  <!-- FIRM ADDRESS LINE 1 -->
                  <v-text-field
                    label="FIRM STREET ADDRESS"
                    name="firmAddressLine"
                    validate-on-blur
                    required
                    id="firmAddressLine"
                    class="ma-2"
                    outlined
                    v-model="firmAddressLine"
                    clearable
                    dense
                  ></v-text-field>
                  <v-text-field
                    label="FIRM CITY, STATE, ZIP"
                    name="firmCityStateZip"
                    validate-on-blur
                    required
                    id="firmCityStateZip"
                    class="ma-2"
                    outlined
                    v-model="firmCityStateZip"
                    clearable
                    dense
                  ></v-text-field>

                  <v-checkbox v-model="agreement" color="light-green accent-1">
                    <template slot="label">
                      I agree to the&nbsp;
                      <a href="#" @click.stop.prevent="dialog = true"
                        >Terms of Service</a
                      >
                      &nbsp;and&nbsp;
                      <a href="#" @click.stop.prevent="dialog = true"
                        >Privacy Policy</a
                      >*
                    </template>
                  </v-checkbox>
                  <v-dialog
                    v-model="dialog"
                    absolute
                    max-width="400"
                    persistent
                  >
                    <v-card>
                      <v-card-title class="headline grey lighten-3"
                        >Legal</v-card-title
                      >
                      <v-card-text>
                        Lorem ipsum dolor sit amet, consectetur adipiscing elit,
                        sed do eiusmod tempor incididunt ut labore et dolore
                        magna aliqua. Ut enim ad minim veniam, quis nostrud
                        exercitation ullamco laboris nisi ut aliquip ex ea
                        commodo consequat. Duis aute irure dolor in
                        reprehenderit in voluptate velit esse cillum dolore eu
                        fugiat nulla pariatur. Excepteur sint occaecat cupidatat
                        non proident, sunt in culpa qui officia deserunt mollit
                        anim id est laborum.
                      </v-card-text>
                      <v-divider></v-divider>
                      <v-card-actions>
                        <v-btn
                          text
                          @click="(agreement = false), (dialog = false)"
                          >No</v-btn
                        >
                        <v-spacer></v-spacer>
                        <v-btn
                          class="white--text"
                          color="light-green accent-1 accent-4"
                          @click="(agreement = true), (dialog = false)"
                          >Yes</v-btn
                        >
                      </v-card-actions>
                    </v-card>
                  </v-dialog>
                  <!-- </v-card> -->
                </div>
              </v-expand-transition>
              <v-layout row>
                <v-spacer></v-spacer>
                <v-btn rounded text outlined class="mt-3" color="red"
                  >CANCEL</v-btn
                >
                <v-spacer></v-spacer>
                <v-btn
                  rounded
                  color="green"
                  dark
                  type="submit"
                  :disabled="!agreement"
                  :loading="loading"
                  class="mt-3"
                  outlined
                >
                  SIGN UP
                  <template v-slot:loader>
                    <span class="custom-loader">
                      <v-icon light>cached</v-icon>
                    </span>
                  </template>
                </v-btn>
                <v-spacer></v-spacer>
              </v-layout>
            </v-form>
          </v-card>
        </v-flex>
        <!-- </v-card> -->
        <!-- </v-flex> -->
      </v-layout>
    </v-container>
  </div>
</template>

<script>
import { mask } from "vue-the-mask";
import * as moment from "moment";
import slugify from "slugify";

export default {
  directives: {
    mask
  },
  data: () => ({
    //
    fullName: "",
    email: "",
    password: "",
    confirmPassword: null,
    agreement: false,
    dialog: false,
    phone: null,
    fax: null,
    firmName: null,
    firmAddressLine: null,
    firmCityStateZip: null,
    firmSlug: null,
    firmCountry: "United States",
    signupDate: null,
    mask: "(###) ###-####",
    // valie: '5555555555',

    rules: {
      email: value => {
        const pattern = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
        return pattern.test(value) || "Invalid e-mail.";
      },
      length: len => v =>
        (v || "").length >= len || `Invalid character length, required ${len}`
      // password: v => (v || '').match(/^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*(_|[^\w])).+$/) ||
      //   'Password must contain an upper case letter, a numeric character, and a special character',
    }
  }),
  computed: {
    user() {
      return this.$store.getters.user;
    },
    //   error() {
    //     return this.$store.getters.error;
    //   },
    loading() {
      return this.$store.getters.loading;
    }
  },
  watch: {
    user(value) {
      if (value !== null && value !== undefined) {
        this.$router.push("/login");

        // if (document.referrer !== document.location.href) {
        //   setTimeout(function() {
        //     document.location.reload();
        //   }, 5000);
        // }
      }
    }
  },
  methods: {
    onSignUp() {
      this.signupDate = moment().format("MMMM Do YYYY, h:mm:ss a");
      if (this.firmName) {
        this.firmSlug = slugify(this.firmName, {
          replacement: "-",
          remove: /[$*_+~.()'"!\-:@,]/g,
          lower: true
        });
      } else {
        return;
      }
      if (this.fullName || this.email)
        if (this.agreement && this.password === this.confirmPassword) {
          let data = {
            email: this.email,
            password: this.password,
            user: {
              signupDate: this.signupDate,
              fullName: this.fullName,
              email: this.email,
              phone: this.phone,
              fax: this.fax,
              firmName: this.firmName,
              firmAddressLine: this.firmAddressLine,
              firmCityStateZip: this.firmCityStateZip,
              firmSlug: this.firmSlug,
              matters: [],
              attorneyList: []
            },
            firm: {
              firmSlug: this.firmSlug,
              firmName: this.firmName,
              firmAddressLine: this.firmAddressLine,
              firmCityStateZip: this.firmCityStateZip,
              firmPhone: this.phone,
              firmFax: this.fax
            }
          };
          console.log("signup", data);
          this.$store.dispatch("signUserUp", data);
        } else {
          return;
        }
    }
    // onDismissed() {
    //   console.log("dismissed alert");
    //   this.$store.dispatch("clearError");
    // }
  }
};
</script>

<style scoped>
.custom-loader {
  animation: loader 1s infinite;
  display: flex;
}
@-moz-keyframes loader {
  from {
    transform: rotate(0);
  }
  to {
    transform: rotate(360deg);
  }
}
@-webkit-keyframes loader {
  from {
    transform: rotate(0);
  }
  to {
    transform: rotate(360deg);
  }
}
@-o-keyframes loader {
  from {
    transform: rotate(0);
  }
  to {
    transform: rotate(360deg);
  }
}
@keyframes loader {
  from {
    transform: rotate(0);
  }
  to {
    transform: rotate(360deg);
  }
}
</style>
